import PoliceCarLineIcon from 'remixicon-react/PoliceCarLineIcon';
import FileDamageLineIcon from 'remixicon-react/FileDamageLineIcon';
import HandCoinLineIcon from 'remixicon-react/HandCoinLineIcon';
import CellphoneLineIcon from 'remixicon-react/CellphoneLineIcon';
import VideoAddLineIcon from 'remixicon-react/VideoAddLineIcon';
import SignalTowerLineIcon from 'remixicon-react/SignalTowerLineIcon';

export const ProfessionalIndemnityFaqList = [
  {
    question: `Is professional indemnity insurance mandatory for doctors in India?`,
    answer: `No, professional indemnity insurance is not mandatory for doctors in India. However, it is recommended that doctors obtain this insurance to protect themselves against any legal liabilities that may arise from their practice.`,
  },
  {
    question: 'What are the benefits of having professional indemnity insurance for doctors?',
    answer: `Professional indemnity insurance offers several benefits to doctors, including financial protection against legal claims, peace of mind, and reputation protection.
      `,
  },
  {
    question: 'How is the premium for professional indemnity insurance for doctors calculated?',
    answer:
      "The premium for professional indemnity insurance for doctors is calculated based on various factors such as the doctor's specialty, experience, and the level of risk involved in their practice.",
  },
  {
    question: 'What should doctors look for when selecting a professional indemnity insurance policy?',
    answer: `When selecting a professional indemnity insurance policy, doctors should consider factors such as coverage limits, the reputation of the insurance provider, the claims settlement process, and the cost of the premium.`,
  },
  {
    question: 'How is Doctors Professional Indemnity (Doctors PI) premium calculated?',
    answer: `The premium will be calculated based on the below factors:
    <li>Risk group of doctors </li>
    <li>Limit of indemnity selected </li>
    <li>Ratio of indemnity limit </li>
    <li>Medical qualification/specialization</li>
    `,
  },
  {
    question: 'What is the difference between public liability and professional indemnity insurance?',
    answer: `Public liability and professional indemnity insurance cover different kinds of risks. Public liability provides coverage if your business has caused damage to property or injury to third parties. In contrast, professional indemnity provides you with coverage  when an incident happens with an individual due to your professional advice.`,
  },
];

export const CyberInsuranceFaqList = [
  {
    question: `Is cyber insurance effective?`,
    answer: `Yes, cyber insurance is effective in providing financial protection and assistance in the face of cyber-related incidents. It helps reduce the financial losses linked with data breaches, cyber attacks, and other cyber threats, facilitating quick and efficient recovery.`,
  },
  {
    question: 'Is it necessary that the computer system used by me be in my own name?',
    answer: `Computer system need not be your personal name. You can use any device which has been securely made available to you. This policy will offer cover for any losses arising out of cyber-attack to that computer system.
      `,
  },
  {
    question: 'Can Financial Loss from the use of my Credit card be covered under any of the Insuring Clauses?',
    answer:
      'If the credit card information has been lost due to cyber intrusion into your computer system and you have suffered from a financial loss as a result of this, it can be covered under IT Theft Loss cover.',
  },
  {
    question: 'Will any insuring clause cover loss of reputation in this policy?',
    answer: `No. However, the legal cost (defense cost if a third party files a case against you or Prosecution costs if you decide to file a criminal case against a third party for reputational damages), will be payable. Whereas, no compensation awarded by the court will be payable under this policy.
    `,
  },
  {
    question: 'Is there any sub-limit, deductible or waiting period under the cyber insurance policy?',
    answer: `No, there is no sub-limit, deductible or waiting period under the cyber insurance online policy.`,
  },
];

export const FirstTabData = [
  {
    icon: PoliceCarLineIcon,
    heading: 'Credit Monitoring',
    description: 'Cyber insurance has become increasingly important in todays digital age',
  },
  {
    icon: FileDamageLineIcon,
    heading: 'Data Restoration',
    description: 'Recreate or recollect Data held by the Company on behalf of a Third Party',
  },
  {
    icon: PoliceCarLineIcon,
    heading: 'Investigation',
    description: 'Expenses to hire a forensics to determine the existence and cause of the Breach',
  },
  {
    icon: HandCoinLineIcon,
    heading: 'Legal Costs',
    description: 'Cyber insurance has become increasingly important in todays digital age',
  },
  {
    icon: CellphoneLineIcon,
    heading: 'Privacy Notification',
    description: 'Expenses incurred to provide notification to individuals who are required to be notified',
  },
  {
    icon: VideoAddLineIcon,
    heading: 'Business Interruption',
    description: 'The Insurer will pay any Interruption Loss, incurred till the specified limit',
  },
  {
    icon: SignalTowerLineIcon,
    heading: 'Crisis Management',
    description: 'PR consultant helps to avert/mitigate damage to the Company’s reputation',
  },
  {
    icon: CellphoneLineIcon,
    heading: 'Cyber Extortion',
    description: 'Security Consultants help to minimize extortion cost or avert it altogether',
  },
];

export const SecondTabData = [
  {
    icon: PoliceCarLineIcon,
    heading: 'Improper Conduct',
    description: 'Dishonest or improper conduct of the insured led to the claim ',
  },
  {
    icon: FileDamageLineIcon,
    heading: 'Physical Injury',
    description: 'Physical injury resulting/caused due to any kind of cyber attack',
  },
  {
    icon: PoliceCarLineIcon,
    heading: 'Property Damage',
    description: 'Property damages resulting/caused due to any kind of cyber attack',
  },
  {
    icon: CellphoneLineIcon,
    heading: 'Unsolicited Communication',
    description: 'Any loss due to unsolicited communication by the policy holder themselves',
  },
  {
    icon: VideoAddLineIcon,
    heading: 'Failures and Malfunctions',
    description: 'Mechanical, electrical and media failure or malfunction',
  },
];

export const CoverageFirstTabData = [
  {
    icon: PoliceCarLineIcon,
    heading: 'Run Off Cover',
    description: 'Cyber insurance has become increasingly important in todays digital age',
  },
  {
    icon: FileDamageLineIcon,
    heading: 'Breach of Confidentiality',
    description: 'Recreate or recollect Data held by the Company on behalf of a Third Party',
  },
  {
    icon: PoliceCarLineIcon,
    heading: 'Loss of Documents',
    description: 'Expenses to hire a forensics to determine the existence and cause of the Breach',
  },
  {
    icon: HandCoinLineIcon,
    heading: 'Dishonesty & Criminal ',
    description: 'Cyber insurance has become increasingly important in todays digital age',
  },
  {
    icon: CellphoneLineIcon,
    heading: 'Out of Court Settlement',
    description: 'Expenses incurred to provide notification to individuals who are required to be notified',
  },
  {
    icon: VideoAddLineIcon,
    heading: 'Continuity Benefit',
    description: 'The Insurer will pay any Interruption Loss, incurred till the specified limit',
  },
  {
    icon: SignalTowerLineIcon,
    heading: 'Reappeal Cost',
    description: 'PR consultant helps to avert/mitigate damage to the Company’s reputation',
  },
  {
    icon: CellphoneLineIcon,
    heading: 'Legal Liabilities',
    description: 'Security Consultants help to minimize extortion cost or avert it altogether',
  },
];

export const ExcludedTabData = [
  {
    icon: PoliceCarLineIcon,
    heading: 'Punitive & Exemplary Damages',
    description: 'Dishonest or improper conduct of the insured led to the claim ',
  },
  {
    icon: FileDamageLineIcon,
    heading: 'Fines and Penalties',
    description: 'Physical injury resulting/caused due to any kind of cyber attack',
  },
  {
    icon: CellphoneLineIcon,
    heading: 'Service under influence',
    description: 'Any loss due to unsolicited communication by the policy holder themselves',
  },
  {
    icon: PoliceCarLineIcon,
    heading: 'Dishonesty & Criminal ',
    description: 'Property damages resulting/caused due to any kind of cyber attack',
  },
];
